import { render, staticRenderFns } from "./PurchasesTableSettingsBtn.vue?vue&type=template&id=320329ce&scoped=true"
import script from "./PurchasesTableSettingsBtn.vue?vue&type=script&lang=js"
export * from "./PurchasesTableSettingsBtn.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTableSettingsBtn.vue?vue&type=style&index=0&id=320329ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320329ce",
  null
  
)

export default component.exports